import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "@/constants/site";

export const Highlights = () => {
  const { t } = useLanguage();
  const images = [IMAGES.alley, IMAGES.sea, IMAGES.pairing];
  const alts = [
    "Dehors nei vicoli storici di Cefalù",
    "Crudo di pesce e gamberi con calici di vino bianco al banco",
    "Tagliere di salumi e formaggi siciliani",
  ];

  return (
    <section id="perche-noi" className="relative py-24 sm:py-32 bg-warm overflow-hidden">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>{t.highlights.chapter}</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08] text-ink">
              {t.highlights.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 space-y-20 sm:space-y-28">
          {t.highlights.items.map((item, i) => (
            <div
              key={item.num}
              className="grid lg:grid-cols-12 gap-8 lg:gap-14 items-center"
              data-testid={`highlight-block-${i + 1}`}
            >
              <Reveal className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div
                  className={`group relative overflow-hidden border border-gold/40 bg-cream shadow-[0_20px_40px_-15px_rgba(59,10,17,0.12)] ${
                    i % 2 === 1 ? "frame-clipped" : "frame-arch"
                  }`}
                >
                  <img
                    src={images[i]}
                    alt={alts[i]}
                    loading="lazy"
                    className={`w-full h-[300px] sm:h-[440px] object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105 ${
                      i % 2 === 1 ? "frame-clipped" : "frame-arch"
                    }`}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-burgundy/25 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                </div>
              </Reveal>

              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <Reveal delay={0.1}>
                  <span className="font-serif italic text-6xl sm:text-7xl text-terracotta/60 leading-none">{item.num}</span>
                </Reveal>
                <Reveal delay={0.18}>
                  <h3 className="mt-4 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight text-ink leading-snug">
                    {item.title}
                  </h3>
                </Reveal>
                <Reveal delay={0.26}>
                  <p className="mt-5 text-base sm:text-lg font-light leading-relaxed text-stone-600 max-w-lg">{item.text}</p>
                </Reveal>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
